import { usePaneLocation } from "@/hooks/pane-routing";

/** Skill id from the open right-pane skill route, or null. */
export function useActiveSkillId(): string | null {
  const paneLocation = usePaneLocation("rightPane");
  const match = paneLocation?.pathname?.match(/^\/skills\/([^/]+)/);
  const id = match?.[1] ?? null;
  if (!id || id === "new") return null;
  return id;
}
